import { render, staticRenderFns } from "./OptionsPopover.vue?vue&type=template&id=50de0241&scoped=true"
import script from "./OptionsPopover.vue?vue&type=script&lang=js"
export * from "./OptionsPopover.vue?vue&type=script&lang=js"
import style0 from "./OptionsPopover.vue?vue&type=style&index=0&id=50de0241&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de0241",
  null
  
)

export default component.exports